import { render, staticRenderFns } from "./HomeMessages.vue?vue&type=template&id=f14294f4&"
import script from "./HomeMessages.vue?vue&type=script&lang=js&"
export * from "./HomeMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports